import { useIntl } from 'react-intl';

import { useTrackEventAmplitude } from '../../../../../../core/Tracking/Amplitude/Amplitude';
import { Button } from '../../../../../../design-system/components/form/button/Button';
import { NavMenuImageCard } from '../../../../../../design-system/components/nav/nav-menu-image-card/NavMenuImageCard';
import { RATIO } from '../../../../../../design-system/components/ratio/Ratio';
import { NormalizedWhereToGoMenu } from '../../../../../../resources/whereToGoMenu/api/prismic/normalizers';
import { useUrlGenerator } from '../../../../../../shared/hooks/useUrlGenerator';
import { MobileMenuTitle } from '../MobileMenuTitle/MobileMenuTitle';

import style from './CampaignView.module.css';

export function CampaignView({
    campaign,
    title,
}: {
    campaign: NonNullable<NonNullable<NormalizedWhereToGoMenu>['campaign']>;
    title: string;
}) {
    const { formatMessage } = useIntl();
    const { generatePath } = useUrlGenerator();
    const { trackEvent } = useTrackEventAmplitude();

    return (
        <div>
            <div>
                <MobileMenuTitle title={title} />
            </div>
            <div className={style.grid}>
                {campaign.thematics.map((thematic, index) => {
                    return (
                        <NavMenuImageCard
                            key={`${index}-${thematic.label}`}
                            label={thematic.label}
                            blur={false}
                            aspectRatio={RATIO['1/1']}
                            href={thematic.url}
                            target={thematic.openInNewTab ? '_blank' : undefined}
                            rel={thematic.openInNewTab ? 'noopener noreferrer' : undefined}
                            image={{
                                alt: thematic.coverImage.card_cover_mobile_retina.alt,
                                src: thematic.coverImage.card_cover_mobile_retina.url,
                                loading: 'lazy',
                                unoptimized: true,
                            }}
                            onClick={() => {
                                trackEvent((ampli, defaultProperties) => {
                                    ampli.primaryNavThematicClicked({
                                        ...defaultProperties,
                                        block: 'primary_nav',
                                        card_number: index + 1,
                                        row_number: 1,
                                        thematic_slug: thematic.url,
                                        click_type: 'card',
                                        column_number: 0,
                                        thematic_group: 'campaign',
                                    });
                                });
                            }}
                        />
                    );
                })}
            </div>

            <div className={style.footer}>
                <Button
                    priority="secondary"
                    reversed
                    href={generatePath('where_to_go')}
                    onClick={() => {
                        trackEvent((ampli, defaultProperties) => {
                            ampli.primaryNavWheretogoClicked({
                                ...defaultProperties,
                                block: 'primary_nav',
                            });
                        });
                    }}
                >
                    {formatMessage({
                        id: 'global.header.globalNav.new.whereToGo.cta',
                    })}
                </Button>
            </div>
        </div>
    );
}
